import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlanningViewPage } from "@/features/rh/planning/components/PlanningViewPage";

export const Route = createFileRoute("/_app/rh/planning/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW),
  staticData: {
    title: "Élément de planning",
    icon: null,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
    module: "rh",
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: PlanningViewPage,
});
